import React from "react";
import NewProducts from "../components/NewProducts";
import "../styles/new.css";
import { useEffect } from "react";

const New = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "New Products";
  }, []);
  return (
    <div>
      <NewProducts />
    </div>
  );
};

export default New;
